import { StarterLayoutStoreSlice, starterLayoutReducer } from "../features";

export interface StarterStoreSlices {
  starterLayout: StarterLayoutStoreSlice;
}

export const starterReducers = {
  starterLayout: starterLayoutReducer,
};
